import Adrienne  from './Adrienne';
import Dana      from './Dana';
import Emily     from './Emily';
import Kate      from './Kate';
import Lauren    from './Lauren';
import Naomi     from './Naomi';
import Neesa     from './Neesa';
import Robin     from './Robin';

const teamMembers = {
    'adrienne-mcconnell': Adrienne,
    'dana-bondy':         Dana,
    'emily-younes':       Emily,
    'kate-fewer':         Kate,
    'lauren-miller':      Lauren,
    'naomi-ha':           Naomi,
    'neesa-kenemy':       Neesa,
    'robin-hurlow':       Robin,
};

export default teamMembers;
